import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { CardActionArea, Paper, Stack, Typography } from "@mui/material";
import { openHunter } from "Components/Hunter/openHunter";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Dashboard.HunterPortalBanner;

export const HunterPortalBanner = () => {
  const { t } = useResource();

  return (
    <Paper
      variant="darkGradient"
      sx={{
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <CardActionArea onClick={openHunter}>
        <Stack direction="row" alignItems="center" gap={2} p={3}>
          <PsychologyIcon sx={{ fontSize: "3rem", color: "common.white" }} />
          <Stack gap={0.5} flex={1}>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              color="common.white"
            >
              {t(RESOURCES.Title)}
            </Typography>
            <Typography variant="body2" color="grey.300">
              {t(RESOURCES.Description)}
            </Typography>
          </Stack>
          <ChevronRightIcon sx={{ fontSize: "2rem", color: "common.white" }} />
        </Stack>
      </CardActionArea>
    </Paper>
  );
};
